import i18n from "locales/i18n";
import range from "lodash/range";
import { getYear } from "date-fns";

export const years = range(1950, getYear(new Date()) + 80, 1);
export const months = [
  i18n.t("datapicker.Month1"),
  i18n.t("datapicker.Month2"),
  i18n.t("datapicker.Month3"),
  i18n.t("datapicker.Month4"),
  i18n.t("datapicker.Month5"),
  i18n.t("datapicker.Month6"),
  i18n.t("datapicker.Month7"),
  i18n.t("datapicker.Month8"),
  i18n.t("datapicker.Month9"),
  i18n.t("datapicker.Month10"),
  i18n.t("datapicker.Month11"),
  i18n.t("datapicker.Month12"),
];

export const monthNames = {
  1: i18n.t("metrics.Month1"),
  2: i18n.t("metrics.Month2"),
  3: i18n.t("metrics.Month3"),
  4: i18n.t("metrics.Month4"),
  5: i18n.t("metrics.Month5"),
  6: i18n.t("metrics.Month6"),
  7: i18n.t("metrics.Month7"),
  8: i18n.t("metrics.Month8"),
  9: i18n.t("metrics.Month9"),
  10: i18n.t("metrics.Month10"),
  11: i18n.t("metrics.Month11"),
  12: i18n.t("metrics.Month12"),
};

export const MothcategoriesMetrics = [
  i18n.t("metrics.Month1"),
  i18n.t("metrics.Month2"),
  i18n.t("metrics.Month3"),
  i18n.t("metrics.Month4"),
  i18n.t("metrics.Month5"),
  i18n.t("metrics.Month6"),
  i18n.t("metrics.Month7"),
  i18n.t("metrics.Month8"),
  i18n.t("metrics.Month9"),
  i18n.t("metrics.Month10"),
  i18n.t("metrics.Month11"),
  i18n.t("metrics.Month12"),
];
